// Utility function to make authenticated fetch calls
export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
  // Get auth token from localStorage
  const token = localStorage.getItem('auth-storage');
  let authToken = null;
  
  if (token) {
    try {
      const authData = JSON.parse(token);
      if (authData.state?.token) {
        authToken = authData.state.token;
      }
    } catch (error) {
      // Ignore parsing errors
    }
  }

  // Add authentication header (don't force Content-Type for FormData)
  const headers: Record<string, string> = {
    ...(authToken && { Authorization: `Bearer ${authToken}` }),
    ...options.headers,
  };
  
  // Only add Content-Type for non-FormData requests
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  // Don't double-add /api if URL already starts with it
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';
  const fullUrl = url.startsWith('http') ? url : `${baseUrl}${url.startsWith('/api') ? '' : ''}${url}`;
  
  // Fix double /api issue - if baseUrl ends with /api and url starts with /api, remove the extra /api
  const finalUrl = fullUrl.replace('/api/api/', '/api/');

  return fetch(finalUrl, {
    ...options,
    headers,
  });
};
